import { format } from "date-fns";

export const dateCovert = (date: string, timeCheck = false) => {
  if (date) {
    if (timeCheck) {
      return format(new Date(date), "dd.MM.yyyy | HH:mm");
    } else {
      return format(new Date(date), "dd.MM.yyyy");
    }
  } else {
    // throw new Error("Invalid date: " + date);
  }
};
